import { Injectable } from "@angular/core";

import { isStorybookRuntime } from "@vattenfall/core";

import { CarouselElementSlideElement } from "./carousel-element-slide.component";

/**
 * Service that stores all {@link CarouselElementSlideElement} found on a page, by its containing carousel's id. Storing
 * the slides by a carousel id allows for multiple carousels on a page.
 *
 * @privateRemarks
 * The ContentChildren decorator can not (currently) be used to extract elements that are originating outside of Angular
 * (the containing page). This is a workaround for that limitation. Note, when running in Storybook, it is expected that
 * no Carousel host element can be found and all slides will be registered on, and returned by, null as key.
 */
@Injectable({ providedIn: "root" })
export class CarouselElementSlideService {
  private readonly slides = new Map<Element | null, Set<CarouselElementSlideElement>>();

  getSlides(hostElement: Element) {
    if (isStorybookRuntime) return this.slides.get(null);
    return this.slides.get(hostElement);
  }

  setSlide(carouselElementSlideElement: CarouselElementSlideElement) {
    const hostElement = isStorybookRuntime ? null : carouselElementSlideElement.elementRef.nativeElement.parentElement;
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    if (this.slides.has(hostElement)) this.slides.get(hostElement)!.add(carouselElementSlideElement);
    else this.slides.set(hostElement, new Set([carouselElementSlideElement]));
  }
}
